import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import HomeContentEditor from './content-editors/HomeContentEditor';
import AboutContentEditor from './content-editors/AboutContentEditor';
import AboutHeroEditor from './content-editors/AboutHeroEditor';
import ServicesContentEditor from './content-editors/ServicesContentEditor';
import AffiliatesContentEditor from './content-editors/AffiliatesContentEditor';
import ResourcesContentEditor from './content-editors/ResourcesContentEditor';
import EventsContentEditor from './content-editors/EventsContentEditor';
import NewsContentEditor from './content-editors/NewsContentEditor';
import MembershipContentEditor from './content-editors/MembershipContentEditor';
import ContactContentEditor from './content-editors/ContactContentEditor';
import { FileEdit } from 'lucide-react';

const PageContentManager = () => {
  return (
    <div>
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <FileEdit className="text-orange-500" size={32} />
          <h2 className="text-3xl font-bold text-gray-900">Page Content Manager</h2>
        </div>
        <p className="text-gray-600">Edit content for each page and section of your website</p>
      </div>

      <Tabs defaultValue="home" className="w-full">
        <TabsList className="grid w-full grid-cols-2 lg:grid-cols-4 mb-8">
          <TabsTrigger value="home" data-testid="tab-home">Home Page</TabsTrigger>
          <TabsTrigger value="about" data-testid="tab-about">About Page</TabsTrigger>
          <TabsTrigger value="services" data-testid="tab-services">Services</TabsTrigger>
          <TabsTrigger value="affiliates" data-testid="tab-affiliates">Affiliates</TabsTrigger>
          <TabsTrigger value="resources" data-testid="tab-resources">Resources</TabsTrigger>
          <TabsTrigger value="events" data-testid="tab-events">Events</TabsTrigger>
          <TabsTrigger value="news" data-testid="tab-news">News</TabsTrigger>
          <TabsTrigger value="membership" data-testid="tab-membership">Membership</TabsTrigger>
          <TabsTrigger value="contact" data-testid="tab-contact">Contact</TabsTrigger>
        </TabsList>

        <TabsContent value="home">
          <HomeContentEditor />
        </TabsContent>

        <TabsContent value="about">
          <div className="space-y-6">
            <AboutHeroEditor />
            <AboutContentEditor />
          </div>
        </TabsContent>

        <TabsContent value="services">
          <ServicesContentEditor />
        </TabsContent>

        <TabsContent value="affiliates">
          <AffiliatesContentEditor />
        </TabsContent>

        <TabsContent value="resources">
          <ResourcesContentEditor />
        </TabsContent>

        <TabsContent value="events">
          <EventsContentEditor />
        </TabsContent>

        <TabsContent value="news">
          <NewsContentEditor />
        </TabsContent>

        <TabsContent value="membership">
          <MembershipContentEditor />
        </TabsContent>

        <TabsContent value="contact">
          <ContactContentEditor />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default PageContentManager;
